
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { TemplateService } from 'src/app/shared/services/template-service';
import { TblWhatsAppTemplate } from 'src/app/shared/models/whatsapp-template';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-whatsapp-template',
  templateUrl: './whatsapp-template.component.html',
  styleUrls: ['./whatsapp-template.component.css']
})
export class WhatsappTemplateComponent implements OnInit {

  sidePanelMode: boolean = false;
  isEditing: boolean;
  whatsAppTemplate: TblWhatsAppTemplate;
  whatsAppTemplates: Observable<TblWhatsAppTemplate[]>;
  allItems: TblWhatsAppTemplate[] = [];
  pagedItems: TblWhatsAppTemplate[] = [];
  pager: any = {};
  modalRef: BsModalRef;
  editDataAvbl: boolean;
  boxTitle: string;
  edit: any;
  startDate: any
  userType: string;
  
  constructor(private templateService: TemplateService,
    private modalService: BsModalService,
    private spinnerService: AppComponent,
    private localStorage:LocalStorageService,
    private notifyService: NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.whatsAppTemplate = new TblWhatsAppTemplate();
    this.getAllData();
    this.startDate = new Date()
  }

  getAllData() {
    this.whatsAppTemplates = this.templateService.getWhatsAppTemplate();
    this.whatsAppTemplates.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  sidePanel(id, isEditing) {
    this.sidePanelMode = true
    this.edit = isEditing
    if (isEditing) {
      this.boxTitle = "Edit Template";

      this.templateService.getWhatsAppTemplateById(id)
        .subscribe(
          resp => {
            this.whatsAppTemplate = resp;
          },
          (error: HttpErrorResponse) => {
            this.editDataAvbl = false;
          });
    }
    else {
      this.boxTitle = "New Template";
      this.whatsAppTemplate = new TblWhatsAppTemplate();
    }
  }


  //Editing Data
  validateForm(): boolean {

    if (!this.whatsAppTemplate.fileAllowed) {
      this.notifyService.showError("Can't Be Blank!", "Error");
      return false;
    }
    else {
      return true;
    }
  }

  create_edit() {

    if (!this.validateForm()) {
      return;
    }
    if (this.edit) {
      this.templateService.saveAndUpdateWhatsAppTemplate(this.whatsAppTemplate).subscribe(resp => {
        if (resp.refNo > 0) {
          this.notifyService.showSuccess("Updated Successfully!", "Success");
          this.sidePanelMode = false
          this.getAllData()
        }
        else {
          this.notifyService.showError(resp.message, "Error")
        }
      });
    }
    else {
      this.templateService.saveAndUpdateWhatsAppTemplate(this.whatsAppTemplate).subscribe(resp => {
        if (resp.refNo > 0) {
          this.notifyService.showSuccess("Saved Successfully!", "Success");
          this.sidePanelMode = false
          this.getAllData()
        }
        else {
          this.notifyService.showError(resp.message, "Error")
        }
      }, (err) => {
        this.notifyService.showError(err, "Error")
      });
    }
  }
  close_clicked() {
    this.sidePanelMode = false
    this.getAllData();
  }
}

